import { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import { useSelector } from 'react-redux';
import {
	getIsSm,
	getPostsRoot,
	getLifebooksChild,
	getUserState,
} from 'redux/selectors';
import * as services from 'services';
import { buildPostRoute, formatDateRender } from 'helpers';
import { useBlockAddPost } from 'helpers/hooks';
import { getPostIntentSearch } from 'components/EditPost/utils/servicePostUtils';
import { Add } from '@mui/icons-material';
import { Menu, MenuItem } from '@mui/material';
import { RoundButton } from 'components';
import styles from '../timeline.module.css';

export const AddPostButton = () => {
	const { childId, feedType } = useParams();
	const isSm = useSelector(getIsSm);
	const root = useSelector(getPostsRoot);
	const child = useSelector(getLifebooksChild);
	const user = useSelector(getUserState);
	const history = useHistory();
	const blockAddPostAccess = useBlockAddPost();
	const [draftsList, setDraftList] = useState([]);
	const [anchorEl, setAnchorEl] = useState(null);
	const open = Boolean(anchorEl);

	useEffect(() => {
		const onGetDraft = async () => {
			const getDrafts =
				feedType === 'services' ? services.getNspDrafts : services.getDrafts;
			let drafts = await getDrafts(childId)
				.then((res) => {
					return res.data?.posts || [];
				})
				.catch(() => {
					return [];
				});
			let items = drafts.map((val, i) => {
				const date = formatDateRender(
					val.updated || val.modifiedAt || val.createdAt || val.posted
				);
				return val ? (
					<MenuItem
						key={`${date}${i}`}
						value={date}
						onClick={(e) => {
							handleClose(e);
							editDraft(val);
						}}>
						{date}
					</MenuItem>
				) : null;
			});
			setDraftList(items);
		};

		const isSupportedFeed = ['timeline', 'services'].includes(feedType);
		const isCaseManagerBlocked =
			user.type === 'case-manager' && child?.privatizePosts;
		if (
			isSupportedFeed &&
			['lifebooks', 'connect'].includes(root) &&
			!isCaseManagerBlocked
		) {
			onGetDraft();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [childId, feedType, root, user.type, child?.privatizePosts]);

	const openMenu = (event) => {
		event.stopPropagation();
		setAnchorEl(event.currentTarget);
	};

	const handleClose = (e) => {
		e.stopPropagation();
		setAnchorEl(null);
	};

	const addPost = () => {
		history.push({
			pathname: buildPostRoute(root, childId),
			search: getPostIntentSearch(feedType),
			state: { feedType },
		});
	};

	const addPostItem = [
		<MenuItem key='add-post' value='add-post' onClick={addPost}>
			Add Post
		</MenuItem>,
		<MenuItem
			className={styles.addPostDraftMenuDivider}
			disabled
			key='drafts-title'>
			Drafts:
		</MenuItem>,
	];

	const editDraft = (val) => {
		history.push({
			pathname: buildPostRoute(root, childId, val.postDraftId),
			search: getPostIntentSearch(feedType),
			state: val,
		});
	};

	const hasDrafts = draftsList.length > 0;

	return !blockAddPostAccess ? (
		<>
			<RoundButton
				Icon={Add}
				onClick={!hasDrafts ? addPost : openMenu}
				buttonClass={[styles.plusButton, isSm && styles.plusButtonSmall].join(
					' '
				)}
				hoverText={`Add a Post`}
				hoverSide='left'
			/>
			<Menu
				anchorEl={anchorEl}
				id='tile-menu'
				keepMounted
				open={open}
				onClose={handleClose}
				PaperProps={{
					style: {
						width: 200,
					},
				}}>
				{addPostItem}
				{draftsList}
			</Menu>
		</>
	) : null;
};

export default AddPostButton;
